import jwtDecode from 'jwt-decode'

// this should be an api call but for now we just hard code
const PAGE_PERMISSIONS = {
  '/login': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  '/admin': [1, 2, 3, 6],
  '/configuration': [1, 2],
  '/data': [1, 2],
  '/chat': [1, 2],
  '/chatadmin': [1, 2],
  '/brands': [1, 2],
  '/users': [1, 2, 3, 6, 8],
  '/storage': [1, 2, 3, 6, 8],
  '/locations': [1, 2, 3, 4, 6, 8, 12, 13],
  '/contacts': [1, 2],
  '/insurance': [1, 2, 3, 4, 5, 6, 8, 9],
  '/fleet': [1, 2, 3, 4, 5, 6, 8, 9],
  '/dashboard': [1, 2, 3, 4, 6, 8],
  '/schedule': [4, 5, 8, 9],
  '/calibrates': [1, 2, 3, 4, 5, 6, 8, 9],
  '/calibrates/Pending': [1, 2, 3, 4, 5, 6, 8, 9],
  '/calibrates/Submitted': [1, 2, 3, 4, 5, 6, 8, 9],
  '/dispatch': [3, 6, 8, 9, 12, 13],
  '/techschedule': [3, 6, 8, 9, 12, 13]
}

export default {
  token: state => state.token,
  passthrough: state => state.passthrough,
  user: state => (state.token ? jwtDecode(state.token) : {}),
  isAllowed: state => {
    return (page = '') => {
      // console.log('Is Allowed', {page: page, roles: state.profile.roles})
      if (!PAGE_PERMISSIONS[page]) {
        return true
      }
      if (state.profile.roles && state.profile.roles.length) {
        return state.profile.roles.some(r => PAGE_PERMISSIONS[page].includes(r))
      }
      return PAGE_PERMISSIONS[page].includes('Guest')
    }
  },
  profile: state => state.profile
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js